import { Component, JSX, h } from 'preact'
import { TFunctionDetailedResult } from 'i18next'
import { i18n } from 'i18n/i18n'

import { ChosenCountry } from 'models/calculator-foreign'

import { getCurrentLanguage } from 'utils/current-language'
import selectHelper from 'app-utils/select-helper'

import SelectPreact, { SelectOption } from 'common-modules/select-preact/select-preact'

interface CalculatorSelectProps {
  payoutOwner: string[]
  chosenItem: ChosenCountry
  onChange: (option: SelectOption) => void
  errorMessageCurrency?: TFunctionDetailedResult | null
  wrapperBoxClassNames?: string
}

interface CalculatorSelectState {
  chosenItem: SelectOption
}

export default class CalculatorSelectCountry extends Component<CalculatorSelectProps, CalculatorSelectState> {
  public render() {
    return (
      <div className={`hero-form__input-block ${this.props.wrapperBoxClassNames}`}>
        <div className="hero-form__input-block-label">
          <div className="hero-form__input-block-label-text">{i18n('calculatorForegin.countryYouSendMoney')}</div>
        </div>
        <div className="hero-form__dropdown-holder hero-form__dropdown-holder-select clearfix">
          <SelectPreact
            id="calculator-county-select"
            name="calculator-county-select"
            options={this.createDropdownOptions()}
            chosenItem={this.createSelectedOption()}
            onChange={this.props.onChange}
            buttonClasses={'in-hero-form-with-currency'}
            listClasses={'is-transfer'}
            isSearch={true}
          />
        </div>
        {this.props.errorMessageCurrency && <p className="hero-form__error-text">{this.props.errorMessageCurrency}</p>}
      </div>
    )
  }

  public getTemplateDropdownOption = (key: string, value: string): JSX.Element => (
    <div className="bem-select-dropdown__choice in-hero-form">
      <div className="hero-form__currency-item clearfix">
        <div className={`hero-form__currency-flag icon-country-round-${key} icon-country-round-${key}-dims`} />
        <div className="hero-form__currency-label-wrapper">
          <div className="hero-form__currency-label">{value}</div>
        </div>
      </div>
    </div>
  )

  public createSelectedOption = (): SelectOption => {
    return selectHelper.createOption(
      this.props.chosenItem.chosenCountryCode,
      this.getTemplateDropdownOption(
        this.props.chosenItem.chosenCountryCode,
        i18n(`countries.${this.props.chosenItem.chosenCountryCode}`)?.toString() || '',
      ),
      this.props.chosenItem.chosenCountryCode,
    )
  }

  public createDropdownOptions = (): SelectOption[] => {
    return this.props.payoutOwner
      .map((value) =>
        selectHelper.createOption(
          value,
          this.getTemplateDropdownOption(value, (i18n(`countries.${value}`) as unknown as string) || ''),
          (i18n(`countries.${value}`) as unknown as string) || '',
        ),
      )
      .sort((a, b) => a.searchValue.localeCompare(b.searchValue, getCurrentLanguage()))
  }
}
